import { toDateTime } from "Helpers/Format";

export const downloadColumns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Título",
    accessor: "title",
  },
  {
    Header: "Descrição",
    accessor: (row) => {
      const txt = document.createElement("div");
      txt.innerHTML = row.description;

      return txt.innerText;
    },
  },
  {
    Header: "URL da Thumbnail",
    accessor: (row) =>
      row.images.map((item, index) => (
        <a href={item} key={index} target="_blank" rel="noreferrer">
          {item.length > 30 ? item.substring(0, 30) + "..." : item}
        </a>
      )),
  },
  {
    Header: "Idealização",
    accessor: (row) => row.details?.idealization,
  },
  {
    Header: "Obra Original",
    accessor: (row) => row.details?.original,
  },
  {
    Header: "Texto",
    accessor: (row) => row.details?.text,
  },
  {
    Header: "Dramaturgia",
    accessor: (row) => row.details?.dramaturgy,
  },
  {
    Header: "Adaptação",
    accessor: (row) => row.details?.adaptation,
  },
  {
    Header: "Direção",
    accessor: (row) => row.details?.direction,
  },
  {
    Header: "Colaboração Artística",
    accessor: (row) => row.details?.artistic_collaboration,
  },
  {
    Header: "Direção Musical",
    accessor: (row) => row.details?.musical_direction,
  },
  {
    Header: "Direção de Produção",
    accessor: (row) => row.details?.production_direction,
  },
  {
    Header: "Direção de Audiovisual",
    accessor: (row) => row.details?.audiovisual_direction,
  },
  {
    Header: "Direção de Arte",
    accessor: (row) => row.details?.art_direction,
  },
  {
    Header: "Coordenação de Produção",
    accessor: (row) => row.details?.production_coordination,
  },
  {
    Header: "Elenco",
    accessor: (row) => row.details?.cast,
  },
  {
    Header: "Cenografia",
    accessor: (row) => row.details?.cenary,
  },
  {
    Header: "Figurino",
    accessor: (row) => row.details?.costumes,
  },
  {
    Header: "Iluminação",
    accessor: (row) => row.details?.lightining,
  },
  {
    Header: "Realização",
    accessor: (row) => row.details?.realization,
  },
  {
    Header: "Link do Ingresso",
    accessor: (row) => row.details?.ticket_link,
  },
  {
    Header: "Local de Estreia",
    accessor: (row) => row.details?.premiere_location,
  },
  {
    Header: "Data de Inativação",
    accessor: (row) =>
      row.inactivated_at ? toDateTime(row.inactivated_at) : "N/A",
  },
  {
    Header: "Data de Criação",
    accessor: (row) => (row.created_at ? toDateTime(row.created_at) : ""),
  },
];

export const columns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Título",
    accessor: "title",
  },
  {
    Header: "Descrição",
    accessor: (row) => {
      const txt = document.createElement("div");
      txt.innerHTML = row.description;

      return txt.innerText.length > 60
        ? txt.innerText.substring(0, 60) + "..."
        : txt.innerText;
    },
  },
  {
    Header: "URL da Thumbnail",
    accessor: (row) => (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          width: "100%",
        }}
      >
        {row.images.map((item, index) => (
          <a href={item} key={index} target="_blank" rel="noreferrer">
            {item.length > 30 ? item.substring(0, 30) + "..." : item}
          </a>
        ))}
      </div>
    ),
  },
  {
    Header: "Data de Inativação",
    accessor: (row) =>
      row.inactivated_at ? toDateTime(row.inactivated_at) : "N/A",
  },
  {
    Header: "Data de Criação",
    accessor: (row) => (row.created_at ? toDateTime(row.created_at) : ""),
  },
];
